import { BUSINESS_NAME } from '#app/utils/business.ts'
import { getOGLocales, type ISupportedLanguage } from '#app/utils/i18n.tsx'
import { BASE_URL } from './config'

export const generateTranslatedMeta = ({
	data,
}: {
	data?: {
		meta?: {
			locale?: ISupportedLanguage
			title?: string
			description?: string
			canonical?: string
		}
	}
}) => {
	return [
		{
			title:
				data?.meta?.title ??
				`Porcelain kitchen countertops and worktops - ${BUSINESS_NAME}`,
		},
		{
			name: 'og:title',
			content:
				data?.meta?.title ??
				`Porcelain kitchen countertops and worktops - ${BUSINESS_NAME}`,
		},
		{
			name: 'og:type',
			content: 'website',
		},
		{
			name: 'og:site_name',
			content: BUSINESS_NAME,
		},
		{
			name: 'description',
			content:
				data?.meta?.description ??
				`${BUSINESS_NAME} makes porcelain kitchen countertops and worktops: the certainty of a concrete, resistent, hygienic material.`,
		},
		{
			tagName: 'link',
			rel: 'canonical',
			href: data?.meta?.canonical ?? `${BASE_URL}`,
		},
		...getOGLocales((data?.meta?.locale ?? 'en') as ISupportedLanguage),
	]
}
